module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card user-card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-content"
  }, [_c('p', {
    staticClass: "title is-5"
  }, [_vm._v(_vm._s(_vm.user.name))])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('small', [_vm._v(_vm._s(_vm.user.email))])])]), _vm._v(" "), _c('footer', {
    staticClass: "card-footer"
  }, [_c('a', {
    staticClass: "card-footer-item",
    on: {
      "click": _vm.editUser
    }
  }, [_vm._v("Editar")]), _vm._v(" "), _c('a', {
    staticClass: "card-footer-item",
    on: {
      "click": _vm.deleteUser
    }
  }, [_vm._v("Apagar")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-image"
  }, [_c('figure', {
    staticClass: "image"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-338b22e5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/UserCard.vue
// module id = 310
// module chunks = 1